import TextField from "@mui/material/TextField";
import { validateIBAN } from "ibantools";
import { FocusEventHandler } from "react";

import { RendererProps } from "../Input";

const IbanField = ({ label, ...props }: RendererProps) => {
  const handleCustomValidation: FocusEventHandler<HTMLInputElement> = (e) => {
    if (e.target.value && !validateIBAN(e.target.value).valid) {
      e.target.setCustomValidity("Voer een correct IBAN nummer in");
    } else {
      e.target.setCustomValidity("");
    }
  };

  return (
    <TextField
      {...props}
      fullWidth
      type="text"
      onInput={handleCustomValidation}
    />
  );
};

export default IbanField;
